import React, { useState, useRef, useEffect } from "react";
import Header from "../Navbar/page";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Api from "../Api/Api";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import { useTimer } from "react-timer-hook";
// import { socket } from "../Socket/page";
import AudioSound from "../sound/audio.mp3";
import WrongSound from "../sound/wrong-answer.mp3";
import { use } from "react";
import useSound from "use-sound";
import { RingLoader } from "react-spinners";


function Page() {
  const [canAnswer, setCanAnswer] = useState(false);
  const [showOptions, setShowOptions] = useState([false, false, false, false]);
  const [pagetNumberDisplay, setPagetNumberDisplay] = useState(1);
  const [answerData, setAnswerData] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [answerCorrect, setAswerCorrect] = useState(false);
  const [answertotalScore, setAnswertotalScore] = useState("");
  const [setinputEditable, setSetinputEditable] = useState(false);
  const [timer, setTimer] = useState(1);
  const [Liveuser, setLiveuser] = useState(0);
  const [MicroDataTime, setMicroDataTime] = useState(0);
  const [startTime, setStartTime] = useState(null); // New state for start time
  const [endTime, setEndTime] = useState(null);
  const [durationDataTime, setDurationDataTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    nanoseconds: 0,
  });
  const [QuestionData, setQuestionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [incorrectAns, setIncorrectAns] = useState();
  const [correctAns, setCorrectAns] = useState();
  const [submittedAns, setSubmittedAns] = useState({});
  const [isAnsSubmitted, setIsAnsSubmitted] = useState(false);
  const [operation, setOperation] = useState({});
  const [isMute, setIsMute] = useState(false);
  const [isQuesError, setIsQuesError] = useState(false);
  const location = useLocation();
  const scrollDown = useRef(null);
  const navigate = useNavigate();
  const [play, { stop }] = useSound(AudioSound);
  const [playWrong, { stopWrong }] = useSound(WrongSound);
  const [LocationStore, setLocationStore] = useState();
  const [isRefreshBlocked, setIsRefreshBlocked] = useState(true);
  const [clickedAns, setClickedAns] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const startTimeRef = useRef(0);
  const intervalRef = useRef(null);
   
  const secretKey = `JcN7GGUEZCP1j4xXZVFeYDkae`;


  const centerDivRef = useRef(null);


  const handleStart = () => {
    const now = new Date();
    setStartTime(now);
    // console.log("startttt----->", now);
    setEndTime(null); // Reset the end time for a new session
    setDurationDataTime(null); // Reset the duration
  };

  // console.log("ismute??", isMute);
  const toggleVolume = (val) => {
    // console.log("toggle Vol");
    setIsMute(val);
  };

  const getMicroseconds = () => {
     

    const timeInMilliseconds = performance.now();
    const timeInMicroseconds = Math.floor(timeInMilliseconds * 1000);

    // Get current date and time using Date object
    const now = new Date();
    const date = now.toISOString().split("T")[0]; // Get YYYY-MM-DD
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // Extract fractional part for microseconds
    const microsecondPart = String(timeInMicroseconds % 1000000).padStart(
      6,
      "0"
    );

    // Combine into final format
    return `${hours}:${minutes}:${seconds}.${microsecondPart}`;
  };

   
  const formatTime = () => {
    const hours = Math.floor(elapsedTime / 3600000);
    const minutes = Math.floor((elapsedTime / 60000) % 60);
    const seconds = Math.floor((elapsedTime / 1000) % 60);
    const milliseconds = Math.floor((elapsedTime % 1000) / 10); // Convert to milliseconds if needed

     
    return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
  }; 

  const quizSteps = [{}];

  const ResultFunction = () => {
    navigate("/resultpage");
  };

  const confirmPagefun = (valuesNumber) => {
    // Log the time
    setAnswerData();
    const valueIncress = valuesNumber + 1;
    setPagetNumberDisplay(valueIncress);
    setSetinputEditable(false);
    // const time = getMicroseconds();
    // Reset the resultId fiel
    scrollDown.current?.scrollIntoView({ behavior: "smooth" });
    if (valuesNumber == operation?.noOfquestion) {
      // console.log("Total time taken in microseconds:--------", timer * 1000);
      // setMicroDataTime(endTime)
      navigate("/resultpage", {
        state: {
          answer: answertotalScore,
          level: operation?.levelStatus,
          gameid: localStorage.getItem("GameId"),
          ques: operation?.noOfquestion,

          // gameid: localStorage.getItem("GameId"),

          // timertemp: timer * 1000,
          timertemp: formatTime(),
        },
      });
    }
  };

  const initialValues = {
    resultId: "",
    result: "",
  };

  const validationFun = yup.object({
    // resultId: yup.number().required("Required"),
    result: yup.string().required("Select your answer"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationFun,
    onSubmit: async (values) => {
      // console.log("Values", values);

      setIsAnsSubmitted(true);
      // window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      setSetinputEditable(true);
      let newScore = answertotalScore || 0; // Ensure prevScore is not undefined
      let isCorrect = false;
      for (let i of QuestionData) {
        if (values.resultId === i.stepNumber) {
          if (values.result == i.correctAnswer) {
            newScore += 20; // Increment score
            isCorrect = true;
            setIncorrectAns();
            setCorrectAns(i.correctAnswer);
            if (!isMute) {
              play();
            }
          } else {
            isCorrect = false;
            setIncorrectAns(values.result);
            setCorrectAns(i.correctAnswer);
            if (!isMute) {
              playWrong();
            }
          }
        }
      } 

      // Set the answer correctness based on the checks
      setAswerCorrect(isCorrect);
      // window.scrollTo({
      //   top: document.body.scrollHeight,
      //   behavior: 'smooth'
      // });

      // Now call Answermatchfun
      await Answermatchfun(values.resultId);
      // console.log("Scrollll", scrollDown.current);
      scrollDown.current?.scrollIntoView({ behavior: "smooth" });

       
      setAnswertotalScore(newScore); // Update the state with the new score
      formik.resetForm();
    },
  });

  const Answermatchfun = async (values) => {
    setAnswerData(values);

     
  };

   
  const getOperationData = async () => {
    try {
      const res = await Api.get(
        `/admin/levelControl?level=${parseInt(location.state.Level)}`
         
      );
      setOperation(res?.data?.result); 
       
      return {
        data: res.data.result,
      };
    } catch (error) {
      console.log("error", error);
    }
  };

  const demiApiQuestiondata = async () => {
    setLoading(true);
    try {
       
      const data = await getOperationData();
       
      const response = await axios.get(
        `https://the-trivia-api.com/v2/questions?limit=${data.data?.noOfquestion}&difficulties=${data.data?.levelStatus}`,
        {
          headers: {
            "X-API-Key": secretKey,
            "Content-Type": "application/json",
          },
        }
      );
       

      const modifiedResults = response?.data?.map(
        (question, index) => ({
          ...question,
          stepNumber: index + 1,
          options: [
            // Corrected to use an array
            ...question.incorrectAnswers.map((answer) => ({ text: answer })), // Map incorrect answers to the desired format
            { text: question.correctAnswer }, // Add the correct answer
          ].sort(() => Math.random() - 0.5), // Replace "YourValue" with the desired value for the new key
        })
      );

      // console.log("DataQuestionModify---->", modifiedResults);
      setQuestionData(modifiedResults);
    } catch (error) {
      if (error.status === 429) {
        const delay = 5000;
        await new Promise((resolve) => setTimeout(resolve, delay));
        setIsQuesError(true);
        // setTimeout(()=>{
        //     setLoading(true);
        // },5000)
        // console.log("Error in question", error);
        setLoading(false);
      }
    }
    setLoading(false);
    setIsQuesError(false);
  };
  useEffect(() => {
  if (QuestionData.length > 0) {
    setCanAnswer(false);
    setShowOptions([false, false, false, false]);

    const unlockTimer = setTimeout(() => setCanAnswer(true), 5000);

    // Always create an array, even if no options
    const timers = (QuestionData[pagetNumberDisplay - 1]?.options || []).map((_, i) =>
      setTimeout(() => {
        setShowOptions(prev => {
          const updated = [...prev];
          updated[i] = true;
          return updated;
        });
      }, 5000 + (i + 1) * 1000)
    );

    return () => {
      clearTimeout(unlockTimer);
      // ✅ Guard against undefined
      if (timers && timers.length) {
        timers.forEach(t => clearTimeout(t));
      }
    };
  }
}, [pagetNumberDisplay, QuestionData]);


  const decodeHtmlEntities = (text) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  useEffect(() => {
    startTimeRef.current = Date.now() - elapsedTime;
    intervalRef.current = setInterval(() => {
      setElapsedTime(Date.now() - startTimeRef.current);
    }, 10);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

   

  const timeoutRef = useRef(null);

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      navigate("/"); // Change to your target route
      localStorage.removeItem("Quizetoken");
      localStorage.removeItem("UserIdclient");
      localStorage.removeItem("UserIdMongo");
      localStorage.removeItem("GameId");
    }, 5 * 60 * 1000); // 30 minutes  1800000
  };

  useEffect(() => {
    resetTimer(); // Start the timer on mount

    const events = ["mousemove", "keydown", "click"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);

   

  useEffect(() => {
    demiApiQuestiondata();
    const loactiondata = location.state ?? "";
    setLocationStore(loactiondata); 
     
  }, []);

  useEffect(() => {
    // Function to handle beforeunload event
    const handleBeforeUnload = (event) => {
      if (isRefreshBlocked) {
        event.preventDefault();
        event.returnValue = ""; // For Chrome compatibility
      }
    };

    // Add the beforeunload event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Set a timeout to unblock refresh after 5 seconds
    const timer = setTimeout(() => {
      setIsRefreshBlocked(false);
    }, 5000);

    // Cleanup function to remove the event listener and timeout
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      clearTimeout(timer);
    };
  }, [isRefreshBlocked]);

   

  useEffect(() => {
 
    if (centerDivRef.current) {
      const parentDiv = centerDivRef.current.parentNode; // Access the parent div

      // Log or manipulate the parent div as needed
      if (parentDiv) {
        const grandParentDiv = parentDiv.parentNode;
        const grandGrandParentDiv = grandParentDiv.parentNode;
        const headerSection = parentDiv.querySelector(".header-section");
        const headerMenu = parentDiv.querySelector(".header-menu");
        const sidebar = grandGrandParentDiv.querySelector(
          ".sidebar.break-point-sm.has-bg-image"
        );

        if (headerSection) headerSection.style.display = "none";
        if (headerMenu) headerMenu.style.display = "none";
        if (sidebar) sidebar.style.display = "none";
      }
    }
  
  }, []);

  useEffect(() => {
    const handlePopState = () => {
         
        navigate("/", { replace: true }); // Navigate to home and replace history
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
        window.removeEventListener("popstate", handlePopState);
    };
}, [navigate]);

  return (
    <>
     {/* <Header /> we do not want to display header when quiz is beingg played*/}

      <div className="wrapper overflow-hidden " ref={centerDivRef}>
        {/* <!-- Top content --> */}
        {loading ? (
          <div style={{ marginTop: "20%", marginLeft: "45%" }}>
            {/* <Loader/> */}
            <RingLoader color="rgb(50 92 213)" size="100" />
          </div>
        ) : (
          <div className="container position-relative">
            {/* <!-- <div className="camera-record"><img src="assets/images/icon/record.png"></div> --> */}

            <div
              onClick={() => {
                // console.log("Clicked");
                toggleVolume(!isMute);
              }}
              className="count_box d-flex float-end pe-1 mr-12"
            >
              <div
                className="progress-right"
                style={{
                  marginTop: "-69px",
                  marginRight: "155px",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    // color: "black",
                    // backgroundColor: "white",
                    // padding: "10px",
                    // border: "2px solid black",
                    borderRadius: "10px",
                    height: "30px",
                    width: "45px",
                    // marginRight: "10px",
                    // marginTop:"18px"
                  }}
                >
                  {!isMute ? (
                    <img src="/assets/images/volume.png" />
                  ) : (
                    <img src="/assets/images/mute (1).png" />
                  )}
                </span>
              </div>
            </div>

            <div className="count_box d-flex float-end pt-5 pe-5 position">
              <div className="count_progress clip-1" style={{ width: "27px" }}>
                {/* <span className="progress-left">
                  <span className="progress_bar"></span>
                </span>
                <span className="progress-right">
                  <span className="progress_bar"></span>
                </span> */}
                {/* <div className="progress-value">
                {/* <div id="value">%</div>
            
              </div>  */}
              </div>

              <span
                style={{
                  color: "black",
                  backgroundColor: "white",
                  padding: "10px",
                  border: "2px solid black",
                  borderRadius: "10px",
                }}
              >
                {/* {formatTime(timer * 100)} */}
                {formatTime().split("s")[0]}s
              </span>
            </div>

            <form
              className="multisteps_form bg-white position-relative overflow-hidden"
              id="wizard"
              onSubmit={formik.handleSubmit}
            >
              {/* <!------------------------- Step-1 -----------------------------> */}
              {/* {loading ? ( */}

              {/* // ) : ( */}
              <div>
                {QuestionData.map((value, index) => (
                  <div key={index}>
                    <div
                      className="multisteps_form_panel step"
                      style={{
                        display:
                          pagetNumberDisplay === value.stepNumber
                            ? "block"
                            : "none",
                      }}
                    >
                      <div className="upper-work">
                        <div className="question_number text-center text-uppercase text-white">
                          <span className="rounded-pill">
                            Question {value.stepNumber} of {" "}
                            {operation?.noOfquestion}
                          </span>
                        </div>

                        <div className="level">
                          <span>
                            <img src="/assets/images/icon/step.png" />
                            Level : {location.state.Level}
                          </span>

                          {/* <span>
                    <img src="/assets/images/icon/family.png" />
                    Lives : 1
                  </span> */}
                        </div>
                      </div>

                      <h2 className="q-heading">
                        {/* Which former British colony was given back to China in 1997? */}
                        {decodeHtmlEntities(value?.question?.text)}
                      </h2>

                      <div className="row pt-5 form_items">
                        <div className="selectYear">
                          <ul key={index}>
                            <div className="row">
                              {value.options.map((item, index) =>
                                showOptions[index] ? (
                                  <div className={`col-6 mb-6 ${showOptions[index] ? "show" : ""}`} key={index}>
                                    <li>
                                      <input
                                        type="radio"
                                        name="result"
                                        value={item.text}
                                        disabled={!canAnswer || setinputEditable}
                                        onChange={(e) => {
                                          setIsAnsSubmitted(false);
                                          setClickedAns(true);
                                          setSubmittedAns({ ans: e.target.value, index });
                                          formik.setFieldValue("result", e.target.value);
                                          formik.setFieldValue("resultId", value.stepNumber);
                                        }}
                                      />
                                      <div
                                        style={{
                                          backgroundColor:
                                            isAnsSubmitted &&
                                            (submittedAns.ans == incorrectAns &&
                                            submittedAns.index == index
                                              ? "red"
                                              : item.text === correctAns
                                              ? "green"
                                              : ""),
                                        }}
                                      >
                                        <h4
                                          style={{
                                            color: isAnsSubmitted
                                              ? submittedAns.ans == incorrectAns &&
                                                submittedAns.index == index
                                                ? "white"
                                                : item.text === correctAns
                                                ? "white"
                                                : "black"
                                              : clickedAns &&
                                                (submittedAns.ans === item.text &&
                                                submittedAns.index == index
                                                  ? "white"
                                                  : "black"),
                                          }}
                                        >
                                          {decodeHtmlEntities(item.text)}
                                        </h4>
                                      </div>
                                    </li>
                                  </div>
                                ) : null
                              )}

                              {formik.touched.result && formik.errors.result ? (
                                <div
                                  className="text-danger"
                                  style={{
                                    float: "right",
                                    padding: "9px",
                                    fontWeight: "600",
                                  }}
                                >
                                  {formik.errors.result}
                                </div>
                              ) : null}

                              {formik.touched.resultId &&
                              formik.errors.resultId ? (
                                <div
                                  className="text-danger"
                                  style={{ float: "right", padding: "9px" }}
                                >
                                  {formik.errors.resultId}
                                </div>
                              ) : null}
                            </div>
                          </ul>
                        </div>

                        <div className="confirm-btn Hidebtn-1" id="ajaxCall">
                          <div id="player">
                            <audio id="audio" controls>
                              <source
                                // src={value.audioSrc}
                                src={AudioSound}
                                // type="audio/aac"
                                type="audio/mpeg"
                                codecs="aac"
                              ></source>
                            </audio>
                            {/* <!-- <input type="checkbox" id="to-lyrics">  --> */}
                            {answerData === value.stepNumber ? (
                              ""
                            ) : showOptions.every(Boolean) ? (
  <div className="cover">
    <div className="controls">
      <button
        id="play-pause"
        title="Play"
        type="submit"
      >
        <div className="next_btn rounded-pill text-uppercase text-white">
          <span>
            <a>Confirm</a>
          </span>
        </div>
      </button>
    </div>
  </div>
) : null}
                            {/* <!-- #cover --> */}
                          </div>
                          {/* <!-- <button type="button" className="next_btn rounded-pill text-uppercase text-white">
                                <span><a href="javascript:void(0)">Confirm  </a></span>         
                  </button></div> --> */}

                          <div className="">
                            {answerData === value.stepNumber ? (
                              <>
                                {answerCorrect ? (
                                  <div className="popup-score">
                                    <h3 className="popup-head">
                                      Hurray! Your Answer is correct.
                                    </h3>
                                    <div className="u_result">
                                      <div className="u_score">
                                        Your Score:{" "}
                                      </div>
                                      {/* <!-- <div className="u_prcnt">20%</div> --> */}
                                      <span>20 Points</span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="popup-score">
                                    <h3 className="popup-head text-danger">
                                      Oops! Your Answer is Incorrect.
                                    </h3>
                                    <div className="u_result">
                                      <div className="u_score">
                                        Your Score:{" "}
                                      </div>
                                      <span>0 Points</span>
                                    </div>
                                  </div>
                                )}

                                <div className="form_btn" ref={scrollDown}>
                                  <a href="#">
                                    <button
                                      type="button"
                                      className="next_btn rounded-pill text-uppercase text-white Hide"
                                      id="nextBtn"
                                      //   onclick="nextPrev(1)"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        confirmPagefun(value.stepNumber);
                                        setIncorrectAns();
                                        setCorrectAns();
                                      }}
                                    >
                                      Next
                                    </button>
                                  </a>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* )} */}
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default Page